import axios from 'axios';

import { IUserPayload } from '@/pages/Checkout/types/paymentLinkContextTypes';

type IIdLink = string | undefined;

const axiosInstance = axios.create({
  baseURL: process.env.MS_PAYMENT_LINK_API,
});

export default axiosInstance;

export const getPaymentLinkById = (paymentLinkId: string | undefined) =>
  axiosInstance.get(`/payment_links/${paymentLinkId}`);

export const getPaymentSimulate = (paymentLinkId: string | undefined) =>
  axiosInstance.get(`/payment_links/${paymentLinkId}/checkout/simulate`);

export const postPaymentLinkPayload = async (
  paymentLinkId: IIdLink,
  userdata: IUserPayload,
) =>
  await axiosInstance.post(
    `/payment_links/${paymentLinkId}/checkout`,
    userdata,
  );

export const postPaymentLinkPayloadWallet = async (
  paymentLinkId: IIdLink,
  userdata: any,
  type: string,
  installments: number,
) =>
  await axiosInstance.post(`/payment_links/${paymentLinkId}/checkout/wallet`, {
    checkout: {
      [type]: userdata,
      type,
      installments,
    },
  });

export const getApplePayValidation = async (
  paymentLinkId: IIdLink,
  validationURL: string,
) =>
  await axiosInstance.post(
    `/payment_links/${paymentLinkId}/checkout/apple_pay_validate_session`,
    {
      validation_url: validationURL,
    },
  );
